import angular from "angular"

/**
 * CustomizationSrv
 * Manages company-specific customization configurations
 */
angular.module("uCountitUiApp").factory("CustomizationSrv", function () {
  // UCNT-6977
  const SM001_CONFIG = {
    // StoreComparison의 커스텀 footfall 레이블 설정
    footfall: {
      // NOTE: "replace" | "extend" - replace: 레이블 목록을 완전히 교체, extend: 기존 레이블 목록에 추가
      behavior: "extend",
      labels: [
        {
          _id: "sm0001",
          name: "당사고객*",
          i18nKey: "당사고객",
          key: "companycustomer",
          isStandardLabel: false,
          queryBy: "name",
        },
      ],
    },
  }

  const service = {
    getCustomConfig: function (company) {
      if (!company || !company.customOverview) {
        return null
      }

      // NOTE: 회사의 customOverview 코드를 회사의 custom code로써 사용
      const customCode = company.customOverview.toLowerCase()

      switch (customCode) {
        case "sm001":
          return SM001_CONFIG
        default:
          return null
      }
    },
  }

  return service
})
